import { IApplicationState } from '../../types/redux';

export const isErrorPopupOpenedSelector = (state: IApplicationState) => state.consultantCianChat.isErrorPopupOpened;
